import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
//import BrazilMap from './BrazilMap';
import PostsChart from './PostsChart';
import HistoricalRead from './HistoricalRead';
import DailyProgressChart from './DailyProgress';
import { useQuery } from '@tanstack/react-query';
import { fetchPosts, fetchBins } from '@/services/streaksApi';
import { Post } from '@/types/streaks';
import BinsChart from './BinsChart';

const StreaksDashboard: React.FC = () => {

    const { 
        data: posts = [], 
        isLoading: postsLoading,
        error: postsError 
    } = useQuery<Post[]>({
        queryKey: ['posts'],
        queryFn: fetchPosts
    });

    const { 
        data: bins = [],
        isLoading: binsLoading,
        error: binsError
    } = useQuery({
        queryKey: ['bins'],
        queryFn: fetchBins
    });

    // const { 
    //     data: stateData = [],
    //     isLoading: stateLoading,
    //     error: stateError 
    // } = useQuery<StateData[]>({
    //     queryKey: ['states'],
    //     queryFn: fetchStateData
    // });

    const loading = postsLoading;
    const error = postsError;

    if (loading) {
        return (
            <div className="flex items-center justify-center h-[400px]">
                <div className="w-8 h-8 border-4 border-t-[#FF3366] rounded-full animate-spin" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-4 text-center text-red-500">
                Falha ao carregar dados. Por favor, tente novamente.
            </div>
        );
    }

    return (
        <div className="container max-w-6xl mx-auto space-y-6">
            <div className="flex flex-col items-center justify-center">
                <span className="pointer-events-none whitespace-pre-wrap bg-gradient-to-b from-[#FF3366] to-[#FF99CC] bg-clip-text text-center text-8xl font-semibold leading-none text-transparent dark:from-[#FF3366] dark:to-[#FF1493]">
                    Streaks
                </span>
            </div>

            {/* Progresso Diário */}
            <DailyProgressChart />

              {/* Distribuição dos Streaks */}
              {binsLoading ? (
                <div className="flex items-center justify-center h-[200px]">
                    <div className="w-8 h-8 border-4 border-t-[#FF3366] rounded-full animate-spin" />
                </div>
            ) : binsError ? (
                <div className="p-4 text-center text-red-500">
                    Falha ao carregar distribuição de streaks.
                </div>
            ) : (
                <BinsChart bins={bins} />
            )}

            {/* Registro de Leitura Histórica */}
            <HistoricalRead />

            {/* Mapa do Brasil
            <Card>
                <CardHeader>
                    <CardTitle className="dark:text-white">Mapa de Distribuição por Estado</CardTitle>
                </CardHeader>
                <CardContent>
                    <BrazilMap data={stateData} />
                </CardContent>
            </Card> */}

            {/* Gráfico de Evolução dos Posts */}
            <Card>
                <CardHeader>
                    <CardTitle className="dark:text-white">Evolução dos Posts</CardTitle>
                </CardHeader>
                <CardContent>
                    <PostsChart posts={posts as any} />
                </CardContent>
            </Card>
        </div>
    );
};

export default StreaksDashboard;
